import { render, staticRenderFns } from "./CameraPageChangeCameraModeButton.vue?vue&type=template&id=06f48364&scoped=true&"
import script from "./CameraPageChangeCameraModeButton.vue?vue&type=script&lang=ts&"
export * from "./CameraPageChangeCameraModeButton.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageChangeCameraModeButton.vue?vue&type=style&index=0&id=06f48364&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f48364",
  null
  
)

export default component.exports